/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-01-21 11:06:38                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-01-21 11:18:34                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * RealmSelector - allow realm selection
    * Set new realm value
*/

/* Imports */
import { Option, Select } from "@material-tailwind/react";
import { useState } from "react";
/***/

/**
* RealmSelector - allow realm selection
* @param onChange - On value change event
*/
export default function RealmSelector({
  onChange
}: {
  onChange?: (value: string) => void
}) {
  const [realm, setRealm] = useState(localStorage.getItem("realm"));
  const realmsList = [
    // {
    //   value: "ro",
    //   label: "Romania"
    // },
    {
      value: "pl",
      label: "Poland"
    }, {
      value: "be",
      label: "Belgium"
    }, {
      value: "lu",
      label: "Luxembourg"
    }
  ];
  
  /**
  * Set new realm value
  * @param val - New value 
  */
  const setRealmEvt = (val: string) => {
    setRealm(val);
    localStorage.setItem("realm", val);
    if (onChange) onChange(val);
  };
  /***/

  return (
    <Select value={realm || ""}
            labelProps={{ className: "hidden" }}
            className="border border-gray-300"
            containerProps={{ className: "min-w-0" }}
            onChange={(e) => setRealmEvt(String(e))}>
      {realmsList.map((el, i) => (
        <Option key={`${i}-${el.value}`} value={el.value}>
          {el.label}
        </Option>
      ))}
    </Select>
  );
}
/***/
